export const dynamicConfigURL = 'config.json';
export const defaultConfig = {
    apiUrl: 'https://stage1-gke-chailease.eupfin.com/sharecar-backstage-government-service',
    fileApiUrl: 'https://stage1-gke-chailease.eupfin.com/sharecar-file-service',
    loginApiUrl: 'https://stage1-gke-chailease.eupfin.com/sharecar-gov-verify-service',
    googleMapsApiKey: 'AIzaSyBrb4V6CKOHZi6hT1O0zZP-3duiai5WVaA',
    reCaptchaKey: ''
};
